module.exports = __webpack_public_path__ + "img/Temu.faf72bbc.png";